import { render, staticRenderFns } from "./BillingTable.vue?vue&type=template&id=0804dc0c&"
import script from "./BillingTable.vue?vue&type=script&lang=ts&"
export * from "./BillingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd})
